export enum Enumroles {
  ADMIN_LODGE = 'of-member_administrator-lodge',
  ADMIN_CAMP = 'of-member_administrator-camp',
  CLERK = 'of-member_clerk',
  FINANCIAL_OFFICER_LODGE = 'of-member_financial-officer-lodge',
  FINANCIAL_OFFICER_CAMP = 'of-member_financial-officer-camp',
  SYSTEM_ADMIN = 'of-member_system-administrator'
}
